import { render, staticRenderFns } from "./UKHomeHero.vue?vue&type=template&id=46053dbc&scoped=true"
import script from "./UKHomeHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./UKHomeHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UKHomeHero.vue?vue&type=style&index=0&id=46053dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46053dbc",
  null
  
)

export default component.exports